export default "/_next/static/b8196784792e453d73394c9345635760.png";